module.exports = __webpack_public_path__ + "img/home-bg.0ccc86bd.jpg";